import { Linkedin } from "lucide-react";
import { FadeUp } from "./Reveal";

const KUNAL_IMG =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_adviser-support-dev/artifacts/wwvtzqd5_Kunal.jfif";
const PARAPLANNER_IMG =
  "https://images.unsplash.com/photo-1718351041906-d1086f502f8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBicml0aXNoJTIwYnVzaW5lc3NtYW4lMjBwb3J0cmFpdCUyMG1vZGVybnxlbnwwfHx8fDE3ODQ3Mzc2ODd8MA&ixlib=rb-4.1.0&q=85";

export const Team = () => (
  <section id="about" className="py-24 md:py-36 bg-parchment-dark relative z-10 border-y border-petrol/15" data-testid="team-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <span className="font-sans text-xs uppercase tracking-[0.28em] text-verdigris">
        Team & Credibility
      </span>
      <FadeUp>
        <h2 className="font-serif text-petrol text-4xl md:text-6xl tracking-tight max-w-3xl mt-8 leading-[1.02]">
          Built by People Who Have Done the Work.
        </h2>
      </FadeUp>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 mt-16 md:mt-20">
        {/* Founder */}
        <FadeUp className="group bg-parchment border border-petrol/20 p-8 md:p-10 flex flex-col sm:flex-row gap-8" data-testid="team-card-founder">
          <div className="shrink-0">
            <div className="w-32 h-40 md:w-40 md:h-52 overflow-hidden border border-petrol/20">
              <img
                src={KUNAL_IMG}
                alt="Kunal Zagde, Founder"
                className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </div>
          <div className="flex flex-col">
            <h3 className="font-serif text-3xl text-petrol">Kunal Zagde</h3>
            <span className="font-sans text-xs uppercase tracking-[0.2em] text-verdigris mt-1 mb-5">
              Founder
            </span>
            <p className="font-sans text-petrol/75 leading-relaxed text-[15px]">
              With deep hands-on expertise in UK paraplanning and financial
              administration, I founded Anchorside Global to bridge the capacity
              gap for growing adviser practices. Having personally prepared
              complex suitability reports and managed technical workflows, I
              understand the precision, compliance standards, and fast turnaround
              UK planners require.
            </p>
            <a
              href="https://www.linkedin.com/in/kunalzagde"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-linkedin"
              className="mt-6 inline-flex items-center gap-2 text-petrol/70 hover:text-verdigris text-sm font-sans transition-colors"
            >
              <Linkedin size={16} /> Connect on LinkedIn
            </a>
          </div>
        </FadeUp>

        {/* Paraplanning Lead */}
        <FadeUp delay={0.12} className="group bg-parchment border border-petrol/20 p-8 md:p-10 flex flex-col sm:flex-row gap-8" data-testid="team-card-paraplanning-lead">
          <div className="shrink-0">
            <div className="w-32 h-40 md:w-40 md:h-52 overflow-hidden border border-petrol/20">
              <img
                src={PARAPLANNER_IMG}
                alt="Paraplanning Lead"
                className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </div>
          <div className="flex flex-col">
            <h3 className="font-serif text-3xl text-petrol">Paraplanning Lead</h3>
            <span className="font-sans text-xs uppercase tracking-[0.2em] text-verdigris mt-1 mb-5">
              Quality & Training
            </span>
            <p className="font-sans text-petrol/75 leading-relaxed text-[15px]">
              Bringing over 4 years of hands-on UK paraplanning experience —
              suitability reports, pension and CGT/IHT calculations, and
              platforms including Intelliflo IO, FE Analytics, and Dynamic
              Planner — he advises on quality standards and training so every
              deliverable meets UK adviser expectations.
            </p>
          </div>
        </FadeUp>
      </div>

      {/* Compliance callout */}
      <FadeUp delay={0.1} className="mt-10 md:mt-14" data-testid="compliance-callout">
        <div className="bg-petrol text-parchment border-l-4 border-verdigris p-10 md:p-16 flex flex-col md:flex-row md:items-center gap-8">
          <span className="font-sans text-xs uppercase tracking-[0.28em] text-verdigris shrink-0">
            Compliance & Data Protection
          </span>
          <p className="font-serif text-2xl md:text-4xl leading-tight tracking-tight">
            Every engagement is built with FCA-regulated firms in mind. Your
            data is handled with UK data protection principles in mind,
            structured around how UK advisory practices actually operate.
          </p>
        </div>
      </FadeUp>
    </div>
  </section>
);
